export default {
  state: {
    app: {
      progress: false,
      reloadableKey: new Date().getTime(),
      loading: false,
    },
  },
  mutations: {
    progress(state, bool) {
      state.app.progress = bool
    },
    refreshReloadableKey(state) {
      state.app.reloadableKey = new Date().getTime()
    },
    loading(state, bool) {
      state.app.loading = bool
    },
  },
  getters:{
    loading: (state) => state.loading
  }
}
